<template>
  <div class="container">
    <form class="change" method="post" action="/" @submit.prevent="change">
      <div class="item first">
        <h2>{{ parseTranslation(OLD_PASS) }}:</h2>
        <input
          type="password"
          v-model="password"
          class="general-input"
          :placeholder="translations[language][PASSWORD]"
          required
        />
      </div>
      <div class="item">
        <h2>{{ parseTranslation(NEW_PASS) }}:</h2>
        <input
          type="password"
          v-model="newPassword"
          class="general-input"
          :placeholder="translations[language][PASSWORD]"
          required
        />
        <input
          type="password"
          v-model="confirmPassword"
          class="general-input"
          :placeholder="translations[language][CONFIRM_PASS]"
          required
        />
      </div>
      <div class="submit-group">
        <button type="submit">
          <span v-if="loading"><Loader color="#fff"/></span>
          <span v-else> {{ parseTranslation(CHANGE) }} </span>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import Loader from '@/components/loading/Loader-3'

import * as translationChange from './index.translations'

const { default: translations, ...translationKeys } = translationChange

export default {
  name: 'change-password',

  components: {
    Loader,
  },

  data() {
    return {
      translations,
      ...translationKeys,
      password: '',
      newPassword: '',
      confirmPassword: '',
      loading: false,
    }
  },

  methods: {
    ...mapActions(['sendMessage', 'surveyRemove', 'logout', 'executeSurveyAPICall']),

    async change() {
      if (this.loading) return

      this.loading = true

      if (!this.newPassword || !this.confirmPassword || !this.password) {
        return this.sendMessage(this.translations[this.language][this.REQUIRED_FIELDS])
      }

      if (this.newPassword !== this.confirmPassword) {
        return this.sendMessage(
          this.translations[this.language][this.ERROR_CONFIRM_PASSWORD],
        )
      }

      const success = await this.executeSurveyAPICall({
        method: 'POST',
        path: '/user/change-password',
        payload: { newPassword: this.newPassword, password: this.password },
      })

      if (!success) return (this.loading = false)

      this.sendMessage(success.message)
      this.surveyRemove()
      this.logout()

      this.loading = false

      this.$router.push('/login')
    },
  },
}
</script>

<style lang="scss" scoped>
.change {
  margin-top: 60px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  form {
    display: flex;
    flex-direction: column;
  }
  button {
    @include btn-style;
    margin: 60px auto 0;
    max-width: 100px;
    display: flex;
    justify-content: center;
  }
}

.item {
  h2 {
    color: #fff;
    @include tipography(24);
    text-align: center;
  }
  input {
    display: block;
    margin: 20px 0;
    background: none;
    border: 1px solid #fff;
    border-radius: 15px;
    padding: 6px 10px;
    color: #fff;
    &:hover,
    &:focus {
      outline: none;
      box-shadow: 0px 0px 6px $gray;
    }
  }
  ::placeholder {
    color: $white;
    opacity: 1;
  }

  ::-webkit-input-placeholder {
    color: $white;
  }

  :-moz-placeholder {
    color: $white;
  }

  ::-moz-placeholder {
    color: $white;
  }

  :-ms-input-placeholder {
    color: $white;
  }
  &.first {
    margin-right: 60px;
  }
  .light & {
    h2,
    input {
      color: $gray-6;
    }
    input {
      border: 1px solid $gray-5;
    }
    ::placeholder {
      color: $gray-6;
      opacity: 1;
    }
    ::-webkit-input-placeholder {
      color: $gray-6;
    }

    :-moz-placeholder {
      /* Firefox 18- */
      color: $gray-6;
    }

    ::-moz-placeholder {
      /* Firefox 19+ */
      color: $gray-6;
    }

    :-ms-input-placeholder {
      color: $gray-6;
    }
  }
}

.submit-group {
  flex-basis: 100%;
}

@media (max-width: 461.98px) {
  .change {
    flex-direction: column;
  }

  .item {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    input {
      max-width: 220px;
      width: 100%;
    }
    &.first {
      margin-right: 0px;
    }
  }
}
</style>
